// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__4sdhd","sendOtp":"AuthorizeToLogin_sendOtp__2pDm3"};